let backend_url =
  "https://api.linkedgolfapp.com";
 
  
exports.backend_url = backend_url;
